<template>
  <div class="page-libs-materials">
    <div class="materials-events">
      <div class="page-libs-materials__title">{{$t('pages.libs.materials.title.events')}}</div>
      <div v-if="!folders.length">{{$t('pages.libs.materials.no-folders')}}</div>
      <EventSmall
        v-for="folder in folders"
        :key="folder.id"
        :event="folder"
        :active="folder.id === filterFolder"
        @click.native="$emit('setFilterFolder', folder.id)"
      />
    </div>
    <div class="materials-block">
      <MaterialsFilters
        :type="viewType"
        @select="setViewType"
        :event="filterFolder"
        @setEvent="$emit('setFilterFolder', $event)"
        :text="filterText"
        @setText="$emit('setTextEvent', $event)"
      >
        <button class="primary border upload" @click="openModal('materials-upload')">
          <img src="@/assets/icons/upload.svg" alt="upload"/>
          <span>{{ $t('pages.libs.materials.upload') }}</span>
        </button>
      </MaterialsFilters>
      <div class="materials-settings">
        <NewSelect class="hide-pc mobile-w-full" @input="setSort" :placeholder="$t('pages.libs.materials.sort-by')" :separator="2"
                   :options="newSortOptions"/>
      </div>
      <MaterialListHeader
          class="hide-mobile"
          :sort-options="sortOptions"
          :grid-view="viewType === 1"
          v-model="sort"
          @change="(s, n) => $emit('change', s)"
      />
      <div class="list-materials" :class="{'list-materials--grid': viewType === 1}">
        <Material
          v-for="item in list"
          :key="item.id"
          v-bind="materialProps"
          :data="item"
          :edit="editMode"
          :grid-view="viewType === 1"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Toggle from '@/components/Toggle'
import Material from '@/components/libs/Material'
import SelectCustom from '@/components/form/SelectCustom'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import getUsers from '@/mixins/getUsers'
import HeaderLib from '@/components/libs/HeaderLib'
import MaterialListHeader from '@/components/libs/MaterialListHeader'
import NewSelect from '@/components/NewSelect'
import MaterialsFilters from '@/components/libs/MaterialsFilters.vue'
import EventSmall from '@/components/events/EventSmall.vue'

export default {
  name: 'MaterialPage',
  components: { EventSmall, MaterialsFilters, NewSelect, MaterialListHeader, HeaderLib, SelectCustom, Material, Toggle},
  mixins: [getUsers],
  props: {
    types: Boolean,
    list: Array,
    materialProps: Object,
    disabledUploads: Boolean,
    filterFolder: Number,
    filterText: String,
  },
  data: (vm) => ({
    selectedSort: [],
    viewType: 2,
    sortOptions: [
      {
        title: vm.$t('pages.libs.materials.sort.name'),
        id: 'name',
        value: 'name',
      },
      {
        title: vm.$t('pages.libs.materials.sort.date'),
        id: 'created_at',
        value: 'created_at',
      },
      {
        title: vm.$t('pages.libs.materials.sort.eventName'),
        id: 'event_name',
        value: 'event_name',
      },
      {
        title: vm.$t('pages.libs.materials.sort.eventType'),
        id: 'event_type',
        value: 'event_type',
      },
    ],
    newSortOptions: [
      {
        title: `${vm.$t('pages.libs.materials.sort.name')} A • Z`,
        id: 'name-asc',
        value: 'name-asc',
      },
      {
        title: `${vm.$t('pages.libs.materials.sort.name')} Z • A`,
        id: 'name-desc',
        value: 'name-desc',
      },
      {
        title: `${vm.$t('pages.libs.materials.sort.type')} A • Z`,
        id: 'type-asc',
        value: 'type-asc',
      },
      {
        title: `${vm.$t('pages.libs.materials.sort.type')} Z • A`,
        id: 'type-desc',
        value: 'type-desc',
      },
      {
        title: `${vm.$t('pages.libs.materials.sort.date')} ↓`,
        id: 'created_at-asc',
        value: 'created_at-asc',
      },
      {
        title: `${vm.$t('pages.libs.materials.sort.date')} ↑`,
        id: 'created_at-desc',
        value: 'created_at-desc',
      },
    ],
    sort: {
      sort: null,
      negative: false,
    },
  }),
  created() {
    this.getFolders();
  },
  computed: {
    editMode() {
      if (this.disabledUploads) {
        return false
      }
      const check = (role) => this.$auth.check(role)
      if (check('platformadmin') || check('admin') || check('expert')) {
        if (this.eventFilter) {
          const currentUser = this.$auth.user()?.id
          return this.events.some((event) => event.id === this.eventFilter && event?.user?.id === currentUser)
        } else {
          return true
        }
      }
      return false
    },
    experts: {
      get() {
        const experts = this.$route.params.experts
        return experts
            ? experts
                .toString()
                .split(',')
                .map((id) => parseInt(id))
            : []
      },
      set(list) {
        this.$router
            .replace({
              params: {
                ...this.$route.params,
                experts: (list && list.join(',')) || undefined,
              },
            })
            .catch(() => {
            })
      },
    },
    eventFilter() {
      return +this.$route.params.event
    },
    expertsEvent() {
      return this.users.expert.map(({id, first_name, last_name}) => ({
        id,
        title: `${first_name} ${last_name}`,
      }))
    },
    ...mapState('events', ['events']),
    ...mapState('folders', ['folders']),
    ...mapGetters('users', ['getUserId']),
    ...mapState(['typesEvent']),
  },
  methods: {
    setViewType(val) {
      this.viewType = val
    },
    setSort(val) {
      if (val.length) {
        val = val[0].split('-')
        this.sort = {
          negative: val[1] !== 'asc',
          sort: val[0],
        }
      } else {
        this.sort = {
          negative: false,
          sort: '',
        }
      }
      this.$emit('change', this.sort)
    },
    editSave() {
      this.$emit('remove', this.removeList)
      this.editCancel()
    },
    editCancel() {
      this.removeList = []
      this.editMode = false
    },
    ...mapMutations(['openModal']),
    ...mapActions('folders', ['getFolders']),
  },
}
</script>

<style lang="scss">
.page-libs-materials {
  display: flex;

  .materials-events {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex-shrink: 0;

    @include mobile() {
      display: none;
    }
  }

  .upload {
    padding-left: 28px;
    padding-right: 28px;
  }

  .materials-block {
    padding-top: 40px;
    padding-left: 40px;

    @include mobile {
      padding: 40px;
      width: 100%;

      button {
        width: 100%;
      }
    }
  }

  .materials-settings {
    margin-bottom: 30px;

    @include mobile {
      display: grid;
      grid-gap: 50px;
    }

    .select-custom {
      @include mobile {
        order: -1;
      }
    }
  }

  .list-materials {
    display: flex;
    flex-direction: column;

    @include mobile {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 20px;
    }

    &--grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-gap: 20px;

      @include mobile {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 20px;
      }
    }
  }
  .mobile-w-full {
    width: 100% !important;
  }
}
</style>
